// Sohbet sesleri. WebAudio ile sentezleniyor: ek dosya, on-yukleme ve
// CORS derdi yok, ses seviyesi ile tini calisma aninda ayarlanabiliyor.
// Eski tek ".ogg bip" hem gonderme hem almada ayni caliyordu ve sertti.

let ctx = null;

function audioCtx() {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return null;
    if (!ctx) ctx = new Ctx();
    // Tarayici sekmesi arka plandayken askiya aliniyor.
    if (ctx.state === "suspended") ctx.resume();
    return ctx;
}

// Tek bir yumusak nota: sert baslangic tiklamasi olmasin diye kisa bir
// yukselis, ardindan ussel sonus.
function tone(c, { freq, start, duration, gain, type = "sine", glideTo = null }) {
    const osc = c.createOscillator();
    const amp = c.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(freq, start);
    if (glideTo) osc.frequency.exponentialRampToValueAtTime(glideTo, start + duration);

    amp.gain.setValueAtTime(0.0001, start);
    amp.gain.exponentialRampToValueAtTime(Math.max(gain, 0.0002), start + 0.012);
    amp.gain.exponentialRampToValueAtTime(0.0001, start + duration);

    osc.connect(amp);
    amp.connect(c.destination);
    osc.start(start);
    osc.stop(start + duration + 0.02);
}

function level(volume) {
    const v = typeof volume === "number" ? volume : 100;
    return Math.min(1, Math.max(0, v / 100));
}

// Giden mesaj: kisa, alcak, tek dokunus. Dikkat cekmemeli.
export function playOutgoing({ volume = 100, enabled = true } = {}) {
    if (!enabled) return;
    const c = audioCtx();
    if (!c) return;
    const g = 0.09 * level(volume);
    if (!g) return;
    const t = c.currentTime;
    tone(c, { freq: 620, glideTo: 430, start: t, duration: 0.11, gain: g, type: "sine" });
}

// Gelen mesaj: iki notali yumusak yukselis. Bildirim hissi verir ama tiz degil.
export function playIncoming({ volume = 100, enabled = true } = {}) {
    if (!enabled) return;
    const c = audioCtx();
    if (!c) return;
    const g = 0.11 * level(volume);
    if (!g) return;
    const t = c.currentTime;
    tone(c, { freq: 784, start: t, duration: 0.1, gain: g, type: "sine" });
    tone(c, { freq: 1046, start: t + 0.085, duration: 0.16, gain: g * 0.85, type: "sine" });
}

// Buton/secim dokunusu: cok kisa ve sessiz.
export function playTap({ volume = 100, enabled = true } = {}) {
    if (!enabled) return;
    const c = audioCtx();
    if (!c) return;
    const g = 0.05 * level(volume);
    if (!g) return;
    tone(c, { freq: 520, start: c.currentTime, duration: 0.05, gain: g, type: "triangle" });
}

// Isaretleyicisi olan cihaz mi? Dokunmatikte mouseenter dokunusla tetiklenip
// hover sesini tik sesinin uzerine bindirirdi.
function hasHoverPointer() {
    try {
        return !!(window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches);
    } catch (e) {
        return true;
    }
}

let lastHoverAt = 0;

// Buton uzerine gelme: cok kisik ve cok kisa. Butonlar arasinda hizli
// gezinirken ust uste binmesin diye kisilma araligi var.
export function playHover({ volume = 100, enabled = true } = {}) {
    if (!enabled || !hasHoverPointer()) return;
    const now = Date.now();
    if (now - lastHoverAt < 130) return;
    lastHoverAt = now;

    const c = audioCtx();
    if (!c) return;
    const g = 0.022 * level(volume);
    if (!g) return;
    tone(c, { freq: 1180, start: c.currentTime, duration: 0.035, gain: g, type: "sine" });
}



// WEBPACK FOOTER //
// ./src/utils/sounds.js